import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import Button from '@/components/button';
import Illustration from '@/components/illustration';
import PageCard from '@/components/page-card';
import Text from '@/components/text';
import useApp from '@/hooks/use-app.hook';

const NotFoundPage: FC = () => {
  const { signedIn } = useApp();
  const navigate = useNavigate();
  const goHomeHref = signedIn ? '/orgs' : '/';

  return (
    <PageCard width={700}>
      <Illustration name="disconnected" />
      <Text bold size="x-large" color="active">
        The page you requested does not exist
      </Text>
      <Text color="active">The URL might be misspelled, or the page may have moved.</Text>

      <Button
        label="Go back home"
        onClick={() => {
          navigate({ to: goHomeHref });
        }}
      />
    </PageCard>
  );
};

export default NotFoundPage;
